<ng-container class="main-wrapper">
    <router-outlet></router-outlet>
</ng-container>